export default class Service {

    static get $inject() {
        return ['gettext'];
    }

    constructor(gettext) {

        this.gettext = gettext;

        this.HAN_UNIT_TYPE = [
            {
                'subType': 0x0101,
                'baseTypeName': 'DECT_OUT',
                'deviceTypeName': 'SDEVTYPE_OUT',
                'deviceDescription':this.gettext("Simple On-Off Switch")
            },
            {
                'subType': 0x0102,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Simple Level Controllable")
            },
            {
                'subType': 0x0103,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Simple Level Control")
            },
            {
                'subType': 0x0104,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Simple Level Controllable Switchable")
            },
            {
                'subType': 0x0105,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Simple Level Control switch")
            },
            {
                'subType': 0x0106,
                'baseTypeName': 'DECT_OUT',
                'deviceTypeName': 'SDEVTYPE_OUT',
                'deviceDescription':this.gettext("AC Outlet")
            },
            {
                'subType': 0x0107,
                'baseTypeName': 'DECT_OUT',
                'deviceTypeName': 'SDEVTYPE_DECT_OUT',
                'deviceDescription':this.gettext("AC Outlet with Simple Power Metering")
            },
            {
                'subType': 0x0108,
                'baseTypeName': 'DECT_OUT',
                'deviceTypeName': 'SDEVTYPE_OUT',
                'deviceDescription':this.gettext("Simple Light")
            },
            {
                'subType': 0x0109,
                'baseTypeName': 'DECT_OUT',
                'deviceTypeName': 'SDEVTYPE_OUT',
                'deviceDescription':this.gettext("Dimmable Light")
            },
            {
                'subType': 0x010A,
                'baseTypeName': 'DECT_OUT',
                'deviceTypeName': 'SDEVTYPE_OUT',
                'deviceDescription':this.gettext("Dimmer Switch")
            },
            {
                'subType': 0x010B,
                'baseTypeName': 'DECT_OUT',
                'deviceTypeName': 'SDEVTYPE_OUT',
                'deviceDescription':this.gettext("Simple Door Lock")
            },
            {
                'subType': 0x010C,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_MAG',
                'deviceDescription':this.gettext("Simple Door")
            },
            {
                'subType': 0x010D,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Simple Power Meter")
            },
            {
                'subType': 0x010E,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Simple Temperature")
            },
            {
                'subType': 0x010F,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Simple Humidity")
            },
            {
                'subType': 0x0110,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Simple Pressure")
            },
            {
                'subType': 0x0200,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_MAG',
                'deviceDescription':this.gettext("Simple Detector")
            },
            {
                'subType': 0x0201,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_MAG',
                'deviceDescription':this.gettext("Magnetic contact")
            },
            {
                'subType': 0x0202,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_PIR',
                'deviceDescription':this.gettext("Window Detector")
            },
            {
                'subType': 0x0203,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_PIR',
                'deviceDescription':this.gettext("Motion Detector")
            },
            {
                'subType': 0x0204,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_SMK',
                'deviceDescription':this.gettext("Smoke Detector")
            },
            {
                'subType': 0x0205,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_GAS',
                'deviceDescription':this.gettext("Gas Detector")
            },
            {
                'subType': 0x0206,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_FLD',
                'deviceDescription':this.gettext("Flood Detector")
            },
            {
                'subType': 0x0207,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_GBD',
                'deviceDescription':this.gettext("Glass Break Detector")
            },
            {
                'subType': 0x0208,
                'baseTypeName': 'DECT_IN',
                'deviceTypeName': 'SDEVTYPE_VIB',
                'deviceDescription':this.gettext("Vibration Detector")
            },
            {
                'subType': 0x0280,
                'baseTypeName': 'DECT_OUT',
                'deviceTypeName': 'SDEVTYPE_OUT',
                'deviceDescription':this.gettext("Siren")
            },
            {
                'subType': 0x0281,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Alertable")
            },
            {
                'subType': 0x0300,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_RMT',
                'deviceDescription':this.gettext("Simple Pendant")
            },
            {
                'subType': 0x0410,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("User Interface")
            },
            {
                'subType': 0x0411,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription': "Generic Application Logic"
            },
            {
                'subType': 0x7F18,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_VBX',
                'deviceDescription': this.gettext("Voice Box")
            },
            {
                'subType': 0x7F19,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_VBX',
                'deviceDescription': this.gettext("Door Bell")
            },
            {
                'subType': 0x7FF0,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription':this.gettext("Crow_H_T_P")
            },
            {
                'subType': 0x7FF1,
                'baseTypeName': 'DECT_ALT',
                'deviceTypeName': 'SDEVTYPE_HAM',
                'deviceDescription': "Crow Temperature"
            },
            {
                'subType': 0x0000,
                'baseTypeName': 'DECT_NONE',
                'deviceTypeName': 'SDEVTYPE_NON',
                'deviceDescription':this.gettext("unknown device")
            },
        ];

        this.DECT_BASE_TYPE = {
            'DECT_IN': 0,
            'DECT_OUT': 1,
            'DECT_ALT': 2,
            'DECT_ALL_UNITS': 3,
            'DECT_NONE': 4
        };

        this.DEVICE_TYPE = {
            0x00: {'deviceTypeDescription': this.gettext('Unknown device                   '), 'deviceTypeName': 'SDEVTYPE_NON               '},
            0x01: {'deviceTypeDescription': this.gettext('Wired                            '), 'deviceTypeName': 'Wired                      '},
            0x09: {'deviceTypeDescription': this.gettext('Zigbee AC Plug                   '), 'deviceTypeName': 'Zigbee                     '},
            0x31: {'deviceTypeDescription': this.gettext('Infrared motion detector         '), 'deviceTypeName': 'SDEVTYPE_PIR               '},
            0x32: {'deviceTypeDescription': this.gettext('Magnetic contact                 '), 'deviceTypeName': 'SDEVTYPE_MAG               '},
            0x33: {'deviceTypeDescription': this.gettext('Pendant remote control           '), 'deviceTypeName': 'SDEVTYPE_RMT               '},
            0x34: {'deviceTypeDescription': this.gettext('Smoke detector                   '), 'deviceTypeName': 'SDEVTYPE_SMK               '},
            0x35: {'deviceTypeDescription': this.gettext('Gas detector                     '), 'deviceTypeName': 'SDEVTYPE_GAS               '},
            0x36: {'deviceTypeDescription': this.gettext('Glass break detector             '), 'deviceTypeName': 'SDEVTYPE_GBD               '},
            0x37: {'deviceTypeDescription': this.gettext('Camera PIR                       '), 'deviceTypeName': 'SDEVTYPE_CAM               '},
            0x38: {'deviceTypeDescription': this.gettext('Flood detector                   '), 'deviceTypeName': 'SDEVTYPE_FLD               '},
            0x39: {'deviceTypeDescription': this.gettext('Magnet & Vibration sensor        '), 'deviceTypeName': 'SDEVTYPE_VIB               '},
            0x3A: {'deviceTypeDescription': this.gettext('Home automation                  '), 'deviceTypeName': 'SDEVTYPE_HAM               '},
            0x3B: {'deviceTypeDescription': this.gettext('Heart & saturation monitor       '), 'deviceTypeName': 'SDEVTYPE_SPO               '},
            0x3C: {'deviceTypeDescription': this.gettext('Temperature-flood-magnet detector'), 'deviceTypeName': 'SDEVTYPE_TFM               '},
            0x3D: {'deviceTypeDescription': this.gettext('Air quality detector             '), 'deviceTypeName': 'SDEVTYPE_TFM               '},
            0x4D: {'deviceTypeDescription': this.gettext('Advanced Air quality detector    '), 'deviceTypeName': 'SDEVTYPE_TFM               '},
            0x3E: {'deviceTypeDescription': this.gettext('Radon detector                   '), 'deviceTypeName': 'SDEVTYPE_RDN               '},
            0x3F: {'deviceTypeDescription': this.gettext('Air pressure detector            '), 'deviceTypeName': 'SDEVTYPE_ARP               '},
            0x40: {'deviceTypeDescription': this.gettext('Smart Siren 2                    '), 'deviceTypeName': 'SDEVTYPE_SMART_SRN         '},
            0x41: {'deviceTypeDescription': this.gettext('Temperature                      '), 'deviceTypeName': 'SDEVTYPE_TMP               '},
            0x42: {'deviceTypeDescription': this.gettext('Magnet & Gate                    '), 'deviceTypeName': 'SDEVTYPE_MAG_GATE'      },
            0x43: {'deviceTypeDescription': this.gettext('Smoke heat                       '), 'deviceTypeName': 'SDEVTYPE_SMK_HEAT          '},
            0x44: {'deviceTypeDescription': this.gettext('Smoke detector (sync)            '), 'deviceTypeName': 'SDEVTYPE_SMK_SYNC          '},
            0x45: {'deviceTypeDescription': this.gettext('Indoor Siren                     '), 'deviceTypeName': 'SDEVTYPE_SRN               '},
            0x46: {'deviceTypeDescription': this.gettext('Smart Siren                      '), 'deviceTypeName': 'SDEVTYPE_SMART_SRN_IN      '},
            0x48: {'deviceTypeDescription': this.gettext('Smoke heat (sync)                '), 'deviceTypeName': 'SDEVTYPE_SMK_HEAT_SYNC     '},
            0x49: {'deviceTypeDescription': this.gettext('New Occupancy                    '), 'deviceTypeName': 'SDEVTYPE_NEW_OCP           '},
            0x51: {'deviceTypeDescription': this.gettext('Bed sensor                       '), 'deviceTypeName': 'SDEVTYPE_BED               '},
            0x52: {'deviceTypeDescription': this.gettext('PIR on CT2035                    '), 'deviceTypeName': 'SDEVTYPE_PIR_CT2035        '},
            0x53: {'deviceTypeDescription': this.gettext('Camera PIR on CT2035             '), 'deviceTypeName': 'SDEVTYPE_CAM_PIR_CT2035    '},
            0x54: {'deviceTypeDescription': this.gettext('Occupancy                        '), 'deviceTypeName': 'SDEVTYPE_OCP               '},
            0x55: {'deviceTypeDescription': this.gettext('Verification Camera              '), 'deviceTypeName': 'SDEVTYPE_VER_CAM           '},
            0x56: {'deviceTypeDescription': this.gettext('Fog generator                    '), 'deviceTypeName': 'SDEVTYPE_FOG               '},
            0x57: {'deviceTypeDescription': this.gettext('AC Plug Output                   '), 'deviceTypeName': 'SDEVTYPE_OUT               '},
            0x59: {'deviceTypeDescription': this.gettext('IO 2*2 Relay Board               '), 'deviceTypeName': 'SDEVTYPE_IO_2_2            '},
            0x93: {'deviceTypeDescription': this.gettext('V13 Icon Keypad                  '), 'deviceTypeName': 'SDEVTYPE_SECTOR_KPD        '},
            0x95: {'deviceTypeDescription': this.gettext('Pro Keypad                       '), 'deviceTypeName': 'SDEVTYPE_KPD               '},
            0x96: {'deviceTypeDescription': this.gettext('Bypass Keypad                    '), 'deviceTypeName': 'SDEVTYPE_KPD               '},
            0x97: {'deviceTypeDescription': this.gettext('Led Indication Keypad            '), 'deviceTypeName': 'SDEVTYPE_KPD               '},
            0x98: {'deviceTypeDescription': this.gettext('Keypad                           '), 'deviceTypeName': 'SDEVTYPE_KPD               '},
            0x99: {'deviceTypeDescription': this.gettext('Advanced Keypad                  '), 'deviceTypeName': 'SDEVTYPE_AVD_KPD           '},
            0xE7: {'deviceTypeDescription': this.gettext('AC Plug Output(DECT)             '), 'deviceTypeName': 'SDEVTYPE_DECT_OUT          '},
            0xE8: {'deviceTypeDescription': this.gettext('Zigbee Dimmable light            '), 'deviceTypeName': 'SDEVTYPE_ZIGBEE_OUT        '},
            0xE9: {'deviceTypeDescription': this.gettext('Zigbee Color light               '), 'deviceTypeName': 'SDEVTYPE_ZIGBEE_OUT        '},
            0xEA: {'deviceTypeDescription': this.gettext('Zigbee Color temperature light   '), 'deviceTypeName': 'SDEVTYPE_ZIGBEE_OUT        '},
            0xA1: {'deviceTypeDescription': this.gettext('Yale Door lock                   '), 'deviceTypeName': 'SDEVTYPE_YALE_DOOR_LOCK_OUT'},
        };

        this.INTERFACES = {
            768: [{keyName:this.gettext('energy'), description:this.gettext('Energy')},
                {keyName:this.gettext('amperage'), description:this.gettext('Current')},
                {keyName:this.gettext('voltage'), description:this.gettext('Voltage')},
                {keyName:this.gettext('instantaneous_power'), description:this.gettext('Instantaneous Power')},
                {keyName:this.gettext('average_power'), description:this.gettext('Average Power')},
                {keyName:this.gettext('frequency'), description:this.gettext('Frequency')},
            ],
            61: [{keyName:this.gettext('gas_value'), description:this.gettext('Air quality')},
                {keyName:this.gettext('gas_level'), description:this.gettext('Air quality')},
                {keyName:this.gettext('humidity'), description:this.gettext('Humidity')},
                {keyName:this.gettext('temperature'), description:this.gettext('Temperature')},
                {keyName:this.gettext('air_pressure'), description:this.gettext('Air Pressure')},],
            77: [{keyName:this.gettext('gas_value'), description:this.gettext('Air quality')},
                {keyName:this.gettext('gas_level'), description:this.gettext('Air quality')},
                {keyName:this.gettext('humidity'), description:this.gettext('Humidity')},
                {keyName:this.gettext('temperature'), description:this.gettext('Temperature')},],
            72: [{keyName:this.gettext('humidity'), description:this.gettext('Humidity')},
                {keyName:this.gettext('temperature'), description:this.gettext('Temperature')},],
            32532: [{keyName:this.gettext('humidity'), description:this.gettext('Humidity')},],
            32533: [{keyName:this.gettext('temperature'), description:this.gettext('Temperature')},],
            32535: [{keyName:this.gettext('air_pressure'), description:this.gettext('Air Pressure')},],
            // 32769: [{keyName:this.gettext('temperature'), description:this.gettext('Temperature')},],
            32770: [{keyName:this.gettext('temperature'), description:this.gettext('Temperature')},],
        };

        this.DEVICE_INTERFACES = {
            0x41: {32770: this.INTERFACES[32770]},
            0x3A: {
                32532: this.INTERFACES[32532],
                32533: this.INTERFACES[32533],
                32535: this.INTERFACES[32535],
            },
            0x3D: {61: this.INTERFACES[61],},
            0x4D: {77: this.INTERFACES[77],},
            0x48: {72: this.INTERFACES[72],},
            0x57: {768: this.INTERFACES[768],},
            0xE7: {768: this.INTERFACES[768],},
        };

        this.TROUBLES = [this.gettext("fire_alarm"), this.gettext("chime_is_off"), this.gettext("fuse_fail"),
            this.gettext("sdcard_fail"), this.gettext("gsm_line_fail"), this.gettext("duress_alarm"),
            this.gettext("wifi_fail"), this.gettext("panic_alarm"), this.gettext("code_attempts_alarm"),
            this.gettext("can_bus_fail"), this.gettext("gprs_fail"), this.gettext("mains_fail"),
            this.gettext("ethernet_fail"), this.gettext("real_time_clock_status"), this.gettext("phone_line_fail"),
            this.gettext("rf_jamming_alarm"), this.gettext("dect_fail"), this.gettext("low_battery"),
            this.gettext("panel_tamper"), this.gettext("medical_alarm")];

        this.ZONE_TROUBLES = [
            this.gettext('tamper_alarm'),
            this.gettext('zone_24H_alarm'),
            this.gettext('battery_low'),
            this.gettext('supervision_alarm'),
            this.gettext('sensor_watch_alarm'),
            this.gettext('state'),
            this.gettext('open'),
        ];

        this.OUTPUT_TROUBLES = [
            this.gettext('monitor_alarm'),
            this.gettext('battery_low'),
            this.gettext('tamper_alarm'),
        ];

        this.KEYPAD_TROUBLES = [
            this.gettext('missing'),
            this.gettext('battery_low'),
            this.gettext('tamper_alarm'),
        ];

        this.USER_TROUBLES = [
            this.gettext('pendant_battery_low'),
        ];

    }

    static get HAN_UNIT_TYPE() {

        return this.HAN_UNIT_TYPE;
    }

    static get DECT_BASE_TYPE() {

        return this.DECT_BASE_TYPE;
    }

    static get DEVICE_TYPE() {

        return this.DEVICE_TYPE;
    }

    static get INTERFACES() {

        return this.INTERFACES;
    }

    static get DEVICE_INTERFACES() {

        return this.DEVICE_INTERFACES;
    }

    static get TROUBLES() {

        return this.TROUBLES;
    }

    static get ZONE_TROUBLES() {

        return this.ZONE_TROUBLES;
    }

    static get OUTPUT_TROUBLES() {

        return this.OUTPUT_TROUBLES;
    }

    static get KEYPAD_TROUBLES() {

        return this.KEYPAD_TROUBLES;
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/services/controlPanelConfig.service.js
 **/